<template>

  <div>
    <el-popover :width="anchoPopover" trigger="click" :placement="windowWidth < 400 ? 'bottom' : 'bottom-end'"
      popper-class="popover-page p-0" :teleported="false" append-to=".options-right-navbar" v-if="isCliente" >

      <template #reference>
        <section class="content-referenc cursor-pointer">
          <font-awesome-icon icon="fas fa-ticket" size="lg" color="white" />
        </section>
      </template>
      
      <section class="content-popover">
        <aplicador-cupon titulo="Canjeador de Cupón" />
      </section>

    </el-popover>
  </div>

</template>

<script setup>
  import useUtils from '@composables/useUtils';
  import useUsuarioStore from '@/store/usuario';
  import { storeToRefs } from 'pinia';
  import AplicadorCupon from './AplicadorCupon.vue';
  const usuario_store = useUsuarioStore();
  const { isCliente } = storeToRefs(usuario_store);

  import {ref,computed} from 'vue';

  
  const {
    windowWidth,
    isScreenMovil
  } = useUtils();


const anchoPopover = computed(() => {
  return isScreenMovil.value ? 320 : 620;
})

</script>

<style lang="scss" scoped>
@use '@variables/variables'  as *;

:deep(.popover-page){
  width:320px;
  border-radius:10px;
  background: transparent !important;
}

:deep(.popover-canjeador){
  // width: 320px;
  background-color: red !important;
}

:deep(.badge-page) {
  margin-left: 0px;
  right: 100px;
  top: -7px;
}
.content-popover {
  padding: 0px;
  width:100%;
  main {



  }
}
</style>